module.exports = __webpack_public_path__ + "media/11.70ad664c.mp3";